export default "__VITE_ASSET__DhC$ZkIe__"